import api from './api';

/** Sudarsan / generic option-strategy instance management. Watchlists are the
 *  shared user-scoped /watchlists (same set used by the Strategies page). */
export const optionStrategyService = {
  registry: () => api.get<any>('/option-strategies/registry'),
  list: () => api.get<any>('/option-strategies'),
  create: (body: any) => api.post<any>('/option-strategies', body),
  update: (id: number, body: any) => api.put<any>(`/option-strategies/${id}`, body),
  remove: (id: number) => api.delete<any>(`/option-strategies/${id}`),
  squareOffAll: (id: number, symbol?: string) => api.post<any>(`/option-strategies/${id}/square-off-all`, symbol ? { symbol } : {}),
  /** Square off ONE multi-leg cycle (chart "Close position" on an engine-mirror synthetic). */
  closeCycle: (cycleId: number) => api.post<any>(`/option-strategies/cycles/${cycleId}/close`),
  log: (id: number, symbol?: string) => api.get<any>(`/option-strategies/${id}/log`, { params: symbol ? { symbol } : {} }),
  // Per-engine default settings (edited on the strategy card; new instances inherit).
  getDefaults: () => api.get<any>('/option-strategies/defaults'),
  saveDefault: (engine: string, config: any) => api.put<any>(`/option-strategies/defaults/${engine}`, { config }),
  backtest: (body: { symbol: string; intervalMinutes: number; fromMs: number; toMs: number; strategyId?: number; engine?: string; config?: any; ivAnnualPct?: number; lots?: number; pricingMode?: 'model' | 'real' }) =>
    api.post<any>('/option-strategies/backtest', body),

  // Shared watchlists (uniform across all engines/pages).
  watchlists: () => api.get<any>('/watchlists'),
  createWatchlist: (name: string, symbols: Array<{ symbol: string; exchange: string }> = []) =>
    api.post<any>('/watchlists', { name, symbols }),
  deleteWatchlist: (id: number) => api.delete<any>(`/watchlists/${id}`),
  addSymbol: (id: number, symbol: string, exchange: string) =>
    api.post<any>(`/watchlists/${id}/symbols`, { symbol, exchange }),
  removeSymbol: (id: number, symbol: string, exchange: string) =>
    api.delete<any>(`/watchlists/${id}/symbols`, { params: { symbol, exchange } }),
};
